import React from "react";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Col, Row, FormGroup, Label } from "reactstrap";
import InputField from "../../../../components/form/InputField";
import { Button } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import schema from "./schema";

import { signupAdminAction } from "../../../../modules/auth/Actions";
import { authIsLoadingSelector } from "../../../../modules/auth/Selectors";

const AdminRegistration = (props) => {
	// added render={()=>} instead of component in every <Field />
	// added renderEl func that returns <InputField/> with the name

	const renderEl = (name) => {
		return <InputField name={name} />;
	};

	const { intl, signupAdmin, authIsLoading } = props;
	return (
		<div className="kt-login__body">
			<div className="kt-login__form">
				<div className="kt-login__title">
					<h3>
						<FormattedMessage id="AUTH.REGISTER_ADMIN.TITLE" />
					</h3>
				</div>
				<Formik
					initialValues={{
						firstName: "",
						lastName: "",
						email: "",
						phone: "",
						address: "",
						city: "",
						country: "",
						province: "",
						zipCode: "",
						userType: ["1"],
						password: "",
					}}
					validationSchema={schema(intl)}
					onSubmit={(values, { setStatus, setSubmitting }) => {
						console.log(values);
						const result = signupAdmin(values);
						console.log({ result });
					}}
				>
					{({ values, handleSubmit }) => (
						<>
							<form className="kt-form" onSubmit={handleSubmit}>
								<Row form>
									<Col md={6}>
										<FormGroup>
											<Label for="firstName">
												{/* First Name */}
												<FormattedMessage id="AUTH.REGISTER_FIRST.NAME" />
											</Label>
											<Field
												type="text"
												name="firstName"
												id="firstName"
												placeholder="First Name"
												render={() => renderEl("firstName")}
											/>
										</FormGroup>
									</Col>

									<Col md={6}>
										<FormGroup>
											<Label for="lastName">
												{/* Last Name */}
												<FormattedMessage id="AUTH.REGISTER_LAST.NAME" />
											</Label>
											<Field
												type="text"
												name="lastName"
												id="lastName"
												placeholder="Last Name"
												render={() => <InputField name="lastName" />}
											/>
										</FormGroup>
									</Col>
								</Row>

								{/* <FormGroup>
                  <Label for="username">Username</Label>
                  <Field
                    type="text"
                    name="username"
                    id="username"
                    placeholder="Enter Your username"
                    render={() => <InputField name="username" />}
                  />
                </FormGroup> */}

								<FormGroup>
									<Label for="email">
										{/* Email */}
										<FormattedMessage id="AUTH.REGISTER_EMAIL" />
									</Label>
									<Field
										type="text"
										name="email"
										id="email"
										placeholder="Enter Your Email"
										render={() => <InputField name="email" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="password">
										<FormattedMessage id="AUTH.REGISTER_PASSWORD" />
									</Label>
									<Field
										type="password"
										name="password"
										id="password"
										placeholder="Enter Your Password"
										render={() => (
											<InputField name="password" type="password" />
										)}
									/>
								</FormGroup>
								<hr />

								<FormGroup>
									<Label for="address">
										{/* Address */}
										<FormattedMessage id="AUTH.REGISTER_ADDRESS" />
									</Label>
									<Field
										type="text"
										name="address"
										id="address"
										placeholder="Enter Your address"
										render={() => <InputField name="address" />}
									/>
								</FormGroup>
								<FormGroup>
									<Label for="country">
										{/* Country */}
										<FormattedMessage id="AUTH.REGISTER_COUNTRY" />
									</Label>
									<Field
										type="text"
										name="country"
										id="country"
										placeholder="Enter Your country"
										render={() => <InputField name="country" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="city">
										{/* City */}
										<FormattedMessage id="AUTH.REGISTER_CITY" />
									</Label>
									<Field
										type="text"
										name="city"
										id="city"
										placeholder="Enter Your city"
										render={() => <InputField name="city" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="province">
										{/* Province */}
										<FormattedMessage id="AUTH.REGISTER_PROVINCE" />
									</Label>
									<Field
										type="text"
										name="province"
										id="province"
										placeholder="Enter Your Province"
										render={() => <InputField name="province" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="phone">
										{/* Phone */}
										<FormattedMessage id="AUTH.REGISTER_PHONE" />
									</Label>
									<Field
										type="text"
										name="phone"
										id="phone"
										placeholder="Enter Your phone"
										render={() => <InputField name="phone" />}
									/>
								</FormGroup>

								<FormGroup>
									<Label for="zipCode">
										{/* Zip Code */}
										<FormattedMessage id="AUTH.REGISTER_ZIPCODE" />
									</Label>
									<Field
										type="text"
										name="zipCode"
										id="zipCode"
										placeholder="Enter Your zipCode"
										render={() => <InputField name="zipCode" />}
									/>
								</FormGroup>

								<div
									className="kt-login__actions"
									style={{ display: "flex", flexDirection: "row-reverse" }}
								>
									<Button disabled={authIsLoading} type="submit">
										{authIsLoading ? "loading ..." : "Sign Up"}
									</Button>
								</div>
							</form>
						</>
					)}
				</Formik>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	authIsLoading: authIsLoadingSelector(state),
});

export default injectIntl(
	connect(mapStateToProps, {
		signupAdmin: signupAdminAction,
	})(AdminRegistration)
);
